// SPDX-License-Identifier: AGPL-3.0-or-later

import MaxxingMarkAsset from '@app/media/images/maxxing-mark.svg?react';
import {msg} from '@lingui/core/macro';
import type React from 'react';

export const APPLICATION_ICON_DESCRIPTOR = msg({
	message: '{productName} application icon',
	comment: 'Accessible label for the Fluxer application icon.',
});

export const FluxerIconMark = (props: React.SVGProps<SVGSVGElement>) => (
	<MaxxingMarkAsset role="img" data-flx="ui.icons.fluxer-icon.img" {...props} />
);
